module.exports = __webpack_public_path__ + "img/poster.59d8d53e.png";